import {ChangeDetectionStrategy, ChangeDetectorRef, Component, DOCUMENT, Inject, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RoutingService} from '@spartacus/core';

import {AimoAuthService} from '../../../service/auth/aimo-auth.service';
import {BehaviorSubject, Subscription} from "rxjs";
import {LOGINFAIL} from "../../../service/auth/login-logout-fail.action";
import {Actions} from "@ngrx/effects";
import {CDC_LOGIN_FAILED} from "../../../service/user/aimo-user.action";
import {AimoRoutingService} from "../../../cms-structure/routing/aimo-routing.service";
import {AimoNavigationService} from "../../../service/navigation/aimo-navigation.service";
import {AimoAuthRedirectService} from "../../../service/auth/aimo-auth-redirect.service";


@Component({
    selector: 'aimo-process-cdc-login',
    templateUrl: './aimo-process-cdc-login.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoProcessCdcLoginComponent implements OnDestroy {
    subscriptions: Subscription = new Subscription();
    loginFailed$ = new BehaviorSubject(false);

    constructor(
        protected authService: AimoAuthService,
        protected routingService: RoutingService,
        protected activatedRoute: ActivatedRoute,
        protected actions: Actions,
        protected router: Router,
        protected cdr: ChangeDetectorRef,
        protected aimoRoutingService: AimoRoutingService,
        protected navigationService: AimoNavigationService,
        protected authRedirectService: AimoAuthRedirectService,
        @Inject(DOCUMENT) protected document: Document,
    ) {
        this.subscriptions.add(
            this.activatedRoute.queryParamMap.subscribe((params) => {
                if (params.get('code')) {
                    this.cdcLogin(params.get('code'));
                } else if (this.navigationService.isInSmartEditMode()) {
                    this.loginFailed$.next(true);
                }
            })
        );
        this.subscriptions.add(
            this.actions.subscribe((action) => {
                if (action.type == LOGINFAIL || action.type == CDC_LOGIN_FAILED) {
                    this.loginFailed$.next(true);
                }
            }),
        );
    }

    cdcLogin(code: string): void {
        if (code) {
            this.authService.cdcLogin(code);
        } else {
            if (!this.navigationService.isInSmartEditMode()) {
                this.authRedirectService.aimoRedirect();
            }
        }
    }

    cdcLogout(): void {
        this.authService.cdcLogout();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
